
export const story_permission= {
    story_optional_permission:[ 'view_story']
}